import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IGetAllEstoqueControleUseCase } from "../../../presentation/useCases/read/get_all_controle_estoque_use_case";
import { IGetAllItemControleUseCase } from "../../../presentation/useCases/read/get_all_item_controle_estoque_use_case";
import { IGetAllEstoqueSaidaUseCase } from "../../../presentation/useCases/read/get_all_sainda_use_case";
import { ControleEstoqueFilter } from "../../models/controle_estoque_filter";
import { ControleEstoque } from "../../models/controle_estoque_lista";
import { ItemControleEstoqueFilter } from "../../models/item_controle_estoque_filter";
import { ItemControleEstoque } from "../../models/item_controle_estoque_lista";
import { SaidaProdutosFilter } from "../../models/saida_produtos_filter";
import { SaidaProduto } from "../../models/saida_produtos_lista";
import { IEstoqueRepository } from "../../repositories/estoque_repository";


export class GetAllItemControleUseCase
  extends BasePaginatedUseCase<ItemControleEstoque>
  implements IGetAllItemControleUseCase {
  constructor(private readonly repository: IEstoqueRepository) {
    super();
  }

  async getAllListagemItemControle(
    filter: ItemControleEstoqueFilter,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {

    const response = await this.repository
      .getAllListagemItemControle(
        filter,
        page,
        rowsPerPage,
      );
    
    this._items = response.items;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
  }
}
